// ====================================================================
// Clients shown in the marquee on the homepage.
//
// To add a real client:
//   1. Drop the logo into src/assets/img/clients/  (SVG or transparent PNG, ~200x60px)
//   2. Import it below.
//   3. Add an object to the CLIENTS array.
//
// Fields:
//   name  — Display name. Shown under the logo and as alt text.
//   logo  — Imported asset.
//   href  — Optional URL. If present, the logo becomes a clickable link.
// ====================================================================

// import placeholder from "../assets/img/clients/placeholder.svg";
// ^ uncomment if you need a placeholder again while editing

import penImage from "../assets/img/clients/Pen.png";


export const CLIENTS = [
	{ name: "Balfurd", logo: "https://backend-near-shore.s3.amazonaws.com/images/Balfud-Linen-Logo-new-H_4.png", href: null },
	{ name: "Specialty Mat", logo: "https://www.specialtymat.com/wp-content/uploads/2019/03/logo.png", href: null },
	{ name: "PennState ", logo: penImage, href: null },
	{ name: "Envision Education", logo: "https://budgettracking.org/static/media/logo.568aec9b0c4650d590f7.png", href: null },
];
